import { BusinessError, lt, parsePaymentCardExpirationDate, showSuccessAlert } from '@mews/framework';
import { createFetchAction } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import prefix from '../prefix';
import { setProfiles } from '../ducks/profiles';
import { setPaymentCards, setPaymentCard } from '../ducks/paymentCards';
import { PAYMENT_CARDS_FETCH } from '../ducks/actionTypes';

const CARD_TOKENIZED = prefix('CARD_TOKENIZED');
const CARD_ADD = prefix('CARD_ADD');

export const addCard =
    ({ type, obfuscatedNumber, holderName, expiration, format, nonce, customerId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { creditCardComponent } = container();
        const enterpriseId = getCurrentEnterpriseId();
        const payload = {
            customerId,
            type,
            obfuscatedNumber,
            holderName,
            format,
            nonce,
            enterpriseId,
        };

        if (expiration) {
            const { year, month } = parsePaymentCardExpirationDate(expiration);
            (payload as $TSFixMe).expiration = `${year}-${month}`;
        }

        const promise = creditCardComponent.addCard(payload).then((data: $TSFixMe) => {
            dispatch(setPaymentCard(data));
            showSuccessAlert({
                description: lt('CardCreatedSuccessMessage', { cardLastDigits: data.lastDigits }),
            });

            return data;
        });
        return dispatch(createFetchAction(CARD_ADD, promise, { scope: customerId })).then(
            ({ value }: $TSFixMe) => value
        );
    };

const pciProxyCreateCard =
    ({ expiration, format, customerId, holderName }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { pciProxyService }: $TSFixMe) => {
        const promise = pciProxyService
            .tokenize()
            .then(({ transactionId }: $TSFixMe) => {
                const data = {
                    nonce: transactionId,
                    customerId,
                    expiration,
                    format,
                    holderName,
                };

                return dispatch(addCard(data));
            })
            .catch(({ error }: $TSFixMe) => {
                throw new BusinessError(error);
            });

        return dispatch(createFetchAction(CARD_TOKENIZED, promise)).then(({ value }: $TSFixMe) => value);
    };

export const addGatewayCard = pciProxyCreateCard;

const fetch =
    (params: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { paymentCardsComponent } = container();
        const enterpriseId = getCurrentEnterpriseId();
        const promise = paymentCardsComponent.getAll({ ...params, enterpriseId }).then((data: $TSFixMe) => {
            const { paymentCards, profiles } = data;
            dispatch(setPaymentCards(paymentCards));

            if (profiles) {
                dispatch(setProfiles(profiles));
            }
            return { paymentCards };
        });
        return dispatch(createFetchAction(PAYMENT_CARDS_FETCH, promise));
    };

export const fetchCardsByAccountId = ({ accountId, extent, ids }: $TSFixMe) =>
    fetch({ accountIds: [accountId], extent, ids });
export const fetchCardsByAccountIds = ({ accountIds, extent, ids }: $TSFixMe) => fetch({ accountIds, extent, ids });
